// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2rW1f","title":"AfterBackImages_title__3yn9R","images":"AfterBackImages_images__2L6Dt"};